module.exports = __webpack_public_path__ + "media/images/bank_images/bancoob-7fd9736fb1f455960022c6114589022b.png";